// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__DvQn9","inner":"styles_inner__VaFA8","responsiveInner":"styles_responsiveInner__lTG_p","close":"styles_close__9K9M_","print":"styles_print__QFW2C","title":"styles_title__Lj694"};
module.exports.__checksum = "9af48a0e0ff6"
